import { Link } from 'react-router-dom';
import { Sprout } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative overflow-hidden mt-32 border-t border-white/5">
      {/* Soft chartreuse glow top */}
      <div aria-hidden className="absolute left-1/2 -translate-x-1/2 top-0 w-[80%] h-[2px] bg-gradient-to-r from-transparent via-chartreuse/40 to-transparent"/>
      {/* Giant wordmark (decorative) */}
      <div aria-hidden className="pointer-events-none select-none absolute inset-x-0 -bottom-12 md:-bottom-20 text-center">
        <div className="font-display font-black tracking-tighter text-white/[0.04] leading-[0.8]"
             style={{ fontSize: 'clamp(80px, 16vw, 260px)' }}>
          AgriNexus
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="relative">
                <div className="absolute inset-0 rounded-xl bg-chartreuse/25 blur-md"/>
                <img src="/logo.png" alt="AgriNexus" className="relative w-10 h-10 rounded-xl object-cover"/>
              </div>
              <span className="font-display text-2xl tracking-tight">AgriNexus</span>
            </div>
            <p className="mt-5 text-sm text-muted-foreground max-w-xs leading-relaxed">
              La terra incontra le persone. Un ecosistema AgriTech per trovare, affittare, acquistare e valorizzare i terreni agricoli italiani.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-chartreuse-foreground mb-4 font-semibold" style={{color:'rgb(180,255,0)'}}>Piattaforma</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/esplora">Esplora terreni</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/mappa">Mappa</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/pubblica">Pubblica terreno</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/come-funziona">Come funziona</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/scopri-agrinexus">Scopri AgriNexus</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] mb-4 font-semibold" style={{color:'rgb(180,255,0)'}}>Legale</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/chi-siamo">Chi siamo</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/contatti">Contatti</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/privacy">Privacy</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/termini">Termini</Link></li>
              <li><Link className="text-muted-foreground hover:text-foreground transition-colors" to="/cookie">Cookie</Link></li>
              <li>
                <button
                  data-testid="footer-cookie-prefs"
                  onClick={()=>{ try{ localStorage.removeItem('agrinexus_cookie_consent_v1'); }catch{} window.location.reload(); }}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  Preferenze cookie
                </button>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] mb-4 font-semibold" style={{color:'rgb(180,255,0)'}}>Ecosistema futuro</div>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li>Professionisti</li>
              <li>Macchinari</li>
              <li>Finanziamenti</li>
              <li>Marketplace</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex items-center justify-between flex-wrap gap-3">
          <div className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} AgriNexus — La terra incontra le persone
          </div>
          <a className="text-xs underline text-muted-foreground hover:text-foreground transition-colors" href="mailto:info@agrinexus.it">info@agrinexus.it</a>
        </div>

        <div className="mt-6 text-[11px] text-muted-foreground/70 leading-relaxed max-w-4xl">
          <strong className="text-foreground/80">Disclaimer:</strong> AgriNexus è un portale annunci digitale.
          Le informazioni sui terreni sono fornite dai proprietari e non sono verificate. AgriNexus non svolge
          attività di mediazione immobiliare ai sensi della L. 39/1989. Le analisi AI e i report sono strumenti
          di supporto informativo, non sostituiscono un agronomo, un geometra o un notaio qualificato.
        </div>
      </div>
    </footer>
  );
}
